import { useContext, useEffect } from 'react'
import { FieldValues, UseFormSetValue } from 'react-hook-form'
import { StoreSettingsContext } from 'store'

export const useSetPublishValue = (setValue: UseFormSetValue<FieldValues>) => {
	const storeCtx = useContext(StoreSettingsContext)

	useEffect(() => {
		setValue('published', storeCtx?.storeSettings?.default_product_publish_value)
	}, [storeCtx?.storeSettings])
}
